import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Typography from '@mui/material/Typography';

interface NoSearchResultsFoundProps {
  searchCriteria?: string;
}

const NoSearchResultsFound = (props: NoSearchResultsFoundProps) => (
  <Grid container alignItems="center" spacing={1}>
    <Grid>
      <SentimentVeryDissatisfiedIcon style={{ verticalAlign: 'middle' }} />
    </Grid>
    <Grid>
      <Typography variant="h6">
        {`Sorry, no results found for ${
          props.searchCriteria || 'the search criteria'
        }.`}
      </Typography>
    </Grid>
  </Grid>
);

export default NoSearchResultsFound;
